<div class="title">{{textKey | translate}}</div>
<div class="text-center p-l-15 p-r-15 subtitle" [innerHTML]="subTextKey | translate"></div>